<!--  -->
<template>
  <div class="">
    <component :is="compName" />
  </div>
</template>

<script>
import basePage from "@/pages/basePage.vue";
import rule1 from "./rules/rule1";
import rule2 from "./rules/rule2";
import rule3 from "./rules/rule3";
import rule4 from "./rules/rule4";
import rule5 from "./rules/rule5";
import rule6 from "./rules/rule6";
import rule7 from "./rules/rule7";
import rule8 from "./rules/rule8";
import rule9 from "./rules/rule9";
import rule10 from "./rules/rule10";
import rule11 from "./rules/rule11";
import rule12 from "./rules/rule12";
import rule13 from "./rules/rule13";
import rule14 from "./rules/rule14";
export default {
  extends: basePage,
  //import引入的组件需要注入到对象中才能使用
  components: {
    rule1,
    rule2,
    rule3,
    rule4,
    rule5,
    rule6,
    rule7,
    rule8,
    rule9,
    rule10,
    rule11,
    rule12,
    rule13,
    rule14,
  },
  data() {
    //这里存放数据
    return {
      compName: "rule1",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    next((vm) => {
      // 通过 `vm` 访问组件实例
      if (to.query && to.query.id) {
        vm.compName = `rule${to.query.id}`;
      }
    });
  },
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>